"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mockjs = _interopRequireDefault(require("mockjs"));

var data = _mockjs.default.mock({
  'items|30': [{
    id: '@id',
    title: '@cword(3, 2)',
    birthday: '@datetime',
    'breed|1': ['英短-蓝猫', '英短-蓝白', '布偶-双色'],
    author: '未知',
    'vaccine|1': ['妙三多 & 一针', '妙三多 & 两针', '未注射'],
    'worm|1': ['体内驱虫', '体外驱虫', '体内&外驱虫', '未驱虫'],
    'status|1': ['已售', '未售'],
    // : ''
    pageviews: '@integer(300, 5000)'
  }]
});

var _default = [{
  url: '/table/list',
  type: 'get',
  response: function response(config) {
    var items = data.items;
    return {
      code: 20000,
      data: {
        total: items.length,
        items: items
      }
    };
  }
}];
exports.default = _default;